import { get_form_url } from '@/utils/form';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-6">
          <div className="md:col-span-5">
            <h3 className="font-heading text-3xl md:text-4xl text-background-50 mb-4">VigorBuy Sheet</h3>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-md mb-6">
              The largest independent Vigorbuy Spreadsheet resource hub. Stay updated with the latest curated finds, buying guides, and shopping resources delivered weekly.
            </p>
            <form
              id="newsletter-footer"
              data-readdy-form
              className="flex flex-col sm:flex-row gap-3 max-w-md"
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget as HTMLFormElement;
                const honeypot = (form.querySelector('[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
                if (honeypot) {
                  const msg = document.getElementById('nl-msg');
                  if (msg) { msg.textContent = 'Thanks for subscribing!'; msg.className = 'text-accent-400 text-xs mt-2'; }
                  return;
                }
                const email = (form.querySelector('[name="email"]') as HTMLInputElement)?.value?.trim();
                if (!email) return;
                try {
                  const url = await get_form_url('Newsletter Signup');
                  await fetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams({ email }),
                  });
                  const msg = document.getElementById('nl-msg');
                  if (msg) { msg.textContent = 'Thanks for subscribing!'; msg.className = 'text-accent-400 text-xs mt-2'; }
                  (form.querySelector('[name="email"]') as HTMLInputElement).value = '';
                } catch {
                  const msg = document.getElementById('nl-msg');
                  if (msg) { msg.textContent = 'Something went wrong. Please try again.'; msg.className = 'text-red-400 text-xs mt-2'; }
                }
              }}
            >
              <div className="hp-field-wrap">
                <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" />
              </div>
              <input
                type="email"
                name="email"
                required
                placeholder="Your email address"
                className="flex-1 bg-transparent border-b border-foreground-600 text-background-50 text-sm py-2.5 px-1 placeholder:text-foreground-500 focus:outline-none focus:border-accent-400 transition-colors"
              />
              <button
                type="submit"
                className="px-6 py-2.5 rounded-full bg-background-50 text-foreground-950 text-sm font-semibold hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                Subscribe
                <i className="ri-arrow-right-line text-sm"></i>
              </button>
            </form>
            <p id="nl-msg" className="text-accent-400 text-xs mt-2"></p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">Quick Links</h4>
            <div className="flex flex-col gap-3">
              <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-400 text-sm hover:text-background-50 transition-colors whitespace-nowrap">Shoes</a>
              <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-400 text-sm hover:text-background-50 transition-colors whitespace-nowrap">Jackets</a>
              <a href="https://kaspreadsheet.com/search-921/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-400 text-sm hover:text-background-50 transition-colors whitespace-nowrap">Bags</a>
              <a href="https://kaspreadsheet.com/search-920/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-400 text-sm hover:text-background-50 transition-colors whitespace-nowrap">Accessories</a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-400 text-sm hover:text-background-50 transition-colors whitespace-nowrap">VigorBuy Sheet</a>
            </div>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">Contact</h4>
            <p className="text-foreground-400 text-sm mb-1">hello@vigorbuy.garden</p>
            <p className="text-foreground-500 text-xs mb-6">Response within 24 hours</p>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">Location</h4>
            <p className="text-foreground-400 text-sm leading-relaxed">Serving shoppers worldwide<br />Updated from the community</p>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-5">
            <a href="#" className="text-foreground-500 hover:text-background-50 transition-colors text-sm whitespace-nowrap">Twitter</a>
            <a href="#" className="text-foreground-500 hover:text-background-50 transition-colors text-sm whitespace-nowrap">Instagram</a>
            <a href="#" className="text-foreground-500 hover:text-background-50 transition-colors text-sm whitespace-nowrap">Discord</a>
          </div>
          <p className="text-foreground-500 text-xs whitespace-nowrap">&copy; 2026 VigorBuy Garden. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-foreground-500 hover:text-background-50 transition-colors text-xs whitespace-nowrap">Privacy Policy</a>
            <a href="#" className="text-foreground-500 hover:text-background-50 transition-colors text-xs whitespace-nowrap">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}